<ts-page [displaySidenav]="false">
  <section main class="main">
    <ts-page-header>
      <ng-container page-header-title>
        <section class="list__top__title-wrapper">
          <h5 class="list__top__title">Fields</h5>
        </section>
      </ng-container>
      <ng-container page-header-action-buttons>
        <section class="list__top__action-buttons">
          <ng-container>
            <ts-button variant="primary" icon="add" [matTooltip]="'Add Custom Field'" (click)="addCustomField()">
              Add Custom Field
            </ts-button>
          </ng-container>
        </section>
      </ng-container>
      <ng-container page-header-action-bar>
        <section class="list__bottom__action-buttons flex justify-between w-full items-center">
          <div class="flex flex-row items-center gap-2">
            <ts-input
              [formControl]="searchInputControl"
              size="sm"
              type="text"
              icon="ts_search"
              class="max-h-ts-input-list-search w-ts-input-list-search"
              placeholder="Search"
            ></ts-input>

            <ts-button
              type="stroked"
              color="accent"
              class="xs:hidden"
              icon="ts_grid"
              [matTooltip]="'Change Object'"
              [matMenuTriggerFor]="menu"
            >
              Object
              <ng-container>
                <ts-badge [value]="type | relatedToTypeTitle: customObjects" [type]="'info'"></ts-badge>
              </ng-container>
            </ts-button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                *ngFor="let relatedToType of relatedToTypes | sortRelatedToType: customObjects"
                [routerLink]="['..', relatedToType.type | lowercase]"
                (click)="onLookupFieldDropDownChange(relatedToType)"
              >
                {{ relatedToType.type | relatedToTypeTitle: customObjects }}
              </button>
            </mat-menu>

            @if (selection.selected.length > 0) {
              <ts-button
                type="stroked"
                color="accent"
                class="xs:hidden"
                icon="ts_layers-alt"
                [matMenuTriggerFor]="bulkActionsMenu"
                [matTooltip]="'Select columns'"
              >
                Bulk Action
              </ts-button>

              <mat-menu #bulkActionsMenu="matMenu">
                @if (this.canLock) {
                  <button mat-menu-item (click)="bulkEdit(selection.selected, null, null, 'lock')">
                    <div class="btn-content">
                      <ts-icon outlined="true" [color]="'black'" icon="ts_lock-alt"></ts-icon>
                      <span>Lock Fields Options</span>
                    </div>
                  </button>
                }
                <button mat-menu-item (click)="bulkEdit(selection.selected, null, null, 'value_hidden')">
                  <div class="btn-content">
                    <ts-icon outlined="true" [color]="'black'" icon="ts_eye"></ts-icon>
                    <span>Hide Value Options</span>
                  </div>
                </button>
                <button mat-menu-item (click)="bulkEdit(selection.selected, null, null, 'excel_pull_locked')">
                  <div class="btn-content">
                    <ts-icon outlined="true" [color]="'black'" icon="ts_file-import"></ts-icon>
                    <span>Excel Pull Options</span>
                  </div>
                </button>
                <button mat-menu-item (click)="bulkEdit(selection.selected, null, null, 'excel_push_locked')">
                  <div class="btn-content">
                    <ts-icon outlined="true" [color]="'black'" icon="ts_file-export"></ts-icon>
                    <span>Excel Push Options</span>
                  </div>
                </button>
                @if (this.canInherit) {
                  <button mat-menu-item (click)="bulkEdit(selection.selected, 'inherited', true)">
                    <div class="btn-content">
                      <ts-icon outlined="true" [color]="'black'" icon="ts_check-square"></ts-icon>
                      <span>Enable Inheritance</span>
                    </div>
                  </button>
                  <button mat-menu-item (click)="bulkEdit(selection.selected, 'inherited', false)">
                    <div class="btn-content">
                      <ts-icon outlined="true" [color]="'black'" icon="ts_square"></ts-icon>
                      <span>Disable Inheritance</span>
                    </div>
                  </button>
                }
                <button mat-menu-item (click)="bulkEdit(selection.selected, 'history', true)">
                  <div class="btn-content">
                    <ts-icon outlined="true" [color]="'black'" icon="ts_check-square"></ts-icon>
                    <span>Enable Audit Log</span>
                  </div>
                </button>
                <button mat-menu-item (click)="bulkEdit(selection.selected, 'history', false)">
                  <div class="btn-content">
                    <ts-icon outlined="true" [color]="'black'" icon="ts_square"></ts-icon>
                    <span>Disable Audit Log</span>
                  </div>
                </button>
                <button mat-menu-item (click)="bulkEdit(selection.selected, 'visibility', false)">
                  <div class="btn-content">
                    <ts-icon outlined="true" [color]="'red'" icon="ts_eye"></ts-icon>
                    <span [style.color]="'#C81E1E'">Unarchive Field</span>
                  </div>
                </button>
                <button mat-menu-item (click)="bulkEdit(selection.selected, 'visibility', true)">
                  <div class="btn-content">
                    <ts-icon outlined="true" [color]="'red'" icon="ts_eye-slash"></ts-icon>
                    <span [style.color]="'#C81E1E'">Archive Field</span>
                  </div>
                </button>
              </mat-menu>
            }
          </div>
          <ts-menu [items]="fieldMenuOptions" />
        </section>
      </ng-container>
    </ts-page-header>

    <ts-tab-group
      class="w-full h-full"
      [tabs]="[
        { label: 'Active Fields', template: activeFieldsTab },
        { label: 'Archived Fields', template: archivedFieldsTab },
      ]"
    >
    </ts-tab-group>
    <ng-template #activeFieldsTab>
      <ng-container
        *ngIf="
          lockableFieldDefs
            | filterBy: ['related_to_type'] : type : eqRelatedToType
            | filterBy: ['archived'] : false : eqArchived
            | filterBy: ['name', 'label'] : (searchValue$ | async)
            | filterBy: [''] : (onlyLocked$ | async) : filterHasLock as activeFiltered
        "
      >
        <ng-container
          *ngIf="
            activeFiltered
              | sortBy: 'asc' : 'label'
              | sortBy: 'asc' : 'hidden'
              | splicer: pagination.page : pagination.size as activePage
          "
        >
          <main class="fields-list table-container" [class.no-padding-bottom]="!activePage.length">
            <div class="fields-table">
              <ts-table
                [columnDefs]="columnDefs"
                [rowData]="activePage"
                [actions]="tsActions"
                [autoHeight]="false"
                [hasCheckboxColumn]="true"
                (selectionChanged)="onSelectionChanged($event)"
              >
              </ts-table>
            </div>
          </main>

          <footer class="footer-section flex justify-end items-center">
            <ts-paginator
              [totalItems]="activeFiltered.length"
              [activePage]="pagination.page + 1"
              [pageSize]="pagination.size"
              (pageChanged)="onPaginationChange.next($event)"
            >
            </ts-paginator>
          </footer>
        </ng-container>
      </ng-container>
    </ng-template>

    <ng-template #archivedFieldsTab>
      <ng-container
        *ngIf="
          lockableFieldDefs
            | filterBy: ['related_to_type'] : type : eqRelatedToType
            | filterBy: ['archived'] : true : eqArchived
            | filterBy: ['name', 'label'] : (searchValue$ | async)
            | filterBy: [''] : (onlyLocked$ | async) : filterHasLock as archivedFiltered
        "
      >
        <ng-container
          *ngIf="
            archivedFiltered
              | sortBy: 'asc' : 'label'
              | sortBy: 'asc' : 'hidden'
              | splicer: pagination.page : pagination.size as archivedPage
          "
        >
          <main class="fields-list table-container" [class.no-padding-bottom]="!archivedPage.length">
            <div class="fields-table">
              <ts-table
                [columnDefs]="columnDefs"
                [rowData]="archivedPage"
                [actions]="tsActions"
                [autoHeight]="false"
                [hasCheckboxColumn]="true"
                (selectionChanged)="onSelectionChanged($event)"
              >
              </ts-table>
            </div>
          </main>

          <footer class="footer-section flex justify-end items-center">
            <ts-paginator
              [totalItems]="archivedFiltered.length"
              [activePage]="pagination.page + 1"
              [pageSize]="pagination.size"
              (pageChanged)="onPaginationChange.next($event)"
            >
            </ts-paginator>
          </footer>
        </ng-container>
      </ng-container>
    </ng-template>
  </section>
</ts-page>
